<template>
    <div class="txtImg" v-if="showBackgroundImage">
        <b-container fluid >

            <!-- Left Section -->
            <b-row v-if="direction == 'L'">
                <b-col sm="12" lg="6">
                    <div class="mdh1">
                        <slot></slot>
                    </div>
                </b-col>
                <b-col sm="12" lg="6" class="mdh2"> 
                    <div class="top-left-borders display-none" v-if="showTLRBorder">
                    </div>
                    <b-img :src="imagesrc" class="random-img" fluid></b-img>
                    <b-img :src="images.playbtn" v-if="showPlayBtn" class="playbtn" fluid></b-img>
                    <cq-btn class="showhow" v-if="showImgText">{{ showImgText }}</cq-btn>
                </b-col>
            </b-row>

            <!-- Right Section -->
            <b-row v-if="direction == 'R'">
                <b-col sm="12" lg="6" class="gg1">
                    <div class="top-right-borders display-none" v-if="showTLRBorder">
                    </div>
                    <b-img :src="imagesrc" fluid class="tgg-img"></b-img>
                    <b-img :src="images.playbtn" v-if="showPlayBtn" id="playbtn" fluid></b-img>
                    <cq-btn class="showhow" v-if="showImgText">{{ showImgText }}</cq-btn>
                </b-col>
                <b-col sm="12" lg="6" class= "float-left"> 
                    <div class="gg2">
                        <slot></slot>
                    </div>
                </b-col>
            </b-row>
        </b-container> 
    </div>
</template>

<script>
import CQButton from '../../components/ui/CQButton.vue'

// Import Images
import playbtn from '../../assets/image/common/playbtn.png'
import gg from '../../assets/image/home/gg.png'

export default {
    name: 'cq-text-image-section',
    components: {
        'cq-btn' : CQButton,
    },
    props: {
        direction: {
            required: true
        },
        imagesrc: {
            required: true
        },
        showPlayBtn: {
            required: false,
            default: false
        },
        showImgText: {
            type: String,
            required: false
        },
        showTLRBorder:{
            required: false,
            default: false
        },
        showBackgroundImage:{
            required: false,
            default: true
        }
    },
    data() {
        return {
            images: { 
                playbtn,
                gg
            },
        }
  }
}
</script>

<style scoped>
/* Left side */
.txtImg >>> .mdh1{
  padding-left: 104.5px !important;
  padding-right: 30px !important;
  padding-top: 45px;
}

.txtImg >>> .playbtn{
    position: absolute;
    top: 270px;
    left: 320px; 
    width: 15% !important;
}

.showhow{
  position: absolute;
  left: 240px;
  z-index: 999;
  bottom: 60px;
}

@media only screen and (max-width: 992px){
  .txtImg >>> .random-img{
    position: relative;
    top: 0;
    left: 0;
  }

  .txtImg >>> .playbtn{
    width: 13% !important;
    position: absolute;
    top: 50%;
    left: 55%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }

  .showhow{
    position: absolute;
    bottom: 1%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }

  .txtImg >>> .mdh1{
    padding: 10px !important;
  }

  .txtImg >>> .display-none{
    display: none;
  }
  
}

/* Desktop View */
@media only screen and (min-width: 992px){
  .txtImg{
    background-image: linear-gradient(var(--secondary-color)45%, #C7C8CA);
    margin-bottom: 20px;
  }
  
  .txtImg >>> .mdh2{
    padding-right: 0 !important;
  }
  
  .top-left-borders{
    border-left: 4px solid var(--primary-color);
    border-top: 4px solid var(--primary-color);
    width: 150px;
    height: 150px;
    position: absolute;
  }

  .txtImg >>> .random-img{
    padding: 30px 0 0 30px;
  }
}

/* End Left side */


/* Right Side */
.txtImg{
  background-image: linear-gradient(var(--secondary-color)45%, #C7C8CA);
  margin-bottom: 20px;
}

.gg1 .top-right-borders{
  border-right: 4px solid var(--primary-color);
  border-top: 4px solid var(--primary-color);
  width: 23%;
  right:20px;
  height: 150px;
  position: absolute;
}

/* Desktop View */
@media only screen and (min-width: 992px){
  .txtImg >>> .gg1{
    padding-left: 0 !important;
  }

  .txtImg >>> .tgg-img{
    padding: 30px 30px 0 0 !important;
  }

  .txtImg >>> .gg2{
    padding-right: 104.5px !important;
    padding-top: 45px;
  }
}
/* End Right Side */
</style>